import { createAsyncThunk } from '@reduxjs/toolkit';
import getConfig from 'next/config';

import type { SCENARIO_STEP, EXTERNAL_SCENARIO_STEP, TPayload } from 'commonTypes/api/scenarios/BaseTypes';
import type { IScenario } from 'commonTypes/api/scenarios/scenario';

import { mergeWithCurrentQuery } from 'shared/lib';
import { enrichNextPayloadWithKaspersky } from 'shared/lib/kaspersky-das';

import type { TScenarioState } from 'entities/scenario';
import { isAllowedScenario, scenarioApi, setScenario } from 'entities/scenario';

interface IGoToNextScenarioThunkArgs {
  step?: SCENARIO_STEP | EXTERNAL_SCENARIO_STEP;
  payload?: TPayload;
}

export const goToNextScenarioThunk = createAsyncThunk<IScenario | undefined, IGoToNextScenarioThunkArgs | undefined>(
  'scenario/goToNext',
  async (args, { dispatch, getState, rejectWithValue }) => {
    const scenarioState = (getState() as TScenarioState).scenario;
    const flowId = scenarioState.currentStep?.flowId;
    const defaultUrl = getConfig().publicRuntimeConfig.creditFullDealWeb;

    if (!flowId) {
      return rejectWithValue({ message: 'Missed flowId in goToNextScenarioThunk' });
    }

    const sourceUrl = window.location.href;

    try {
      const payload = await enrichNextPayloadWithKaspersky(args?.payload);

      const response = await dispatch(
        scenarioApi.endpoints.nextStep.initiate({ step: args?.step, flowId, payload, sourceUrl }),
      ).unwrap();

      if (response.redirectUrl) {
        window.location.href = mergeWithCurrentQuery(response.redirectUrl);
        return;
      }

      if (!isAllowedScenario(response.step)) {
        window.location.href = mergeWithCurrentQuery(defaultUrl);
        return;
      }

      dispatch(setScenario(response));

      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
